import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";

const ActionElement = (props) => {
  const { label, className, handleOnClick, title } = props;

  const onClick = e => handleOnClick(e);

  // If label exists, use MUI Button (for Add Filter, etc.)
  // If no label, use plain button with CSS styling (for delete icon)
  if (label) {
    return (
      <Button
        className={className}
        title={title}
        onClick={onClick}
        size="small"
      >
        {label}
      </Button>
    );
  }

  return (
    <button className={className}
      title={title}
      onClick={onClick}>
      {label}
    </button>
  );
};

ActionElement.displayName = "ActionElement";

ActionElement.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  handleOnClick: PropTypes.func,
  title: PropTypes.string,
};

export default ActionElement;